/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "common": {
            "nested": {
              "CustomerPresence": {
                "values": {
                  "present": 1,
                  "online": 2,
                  "phone": 3,
                  "recurring": 4
                }
              },
              "OperationStatus": {
                "fields": {
                  "createdAtMs": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "isSuccess": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ClientPaymentKey": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "requestId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ReverseOptions": {
                "fields": {
                  "userInitiated": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "serverInitiated": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "isTivoReplay": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "online": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                }
              },
              "TivoRecord": {
                "fields": {
                  "encryptedTrackKeyId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "encryptedTrack": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": ".squareup.esperanto.common.TivoRecord.Reason",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Reason": {
                    "values": {
                      "UNKNOWN": 0,
                      "LATENCY": 1,
                      "GATEWAY_ERROR": 2,
                      "OTHER_ERROR": 3
                    }
                  }
                }
              },
              "BillInfo": {
                "fields": {
                  "billToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "billCreatedAt": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "billCompletedAt": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "MoneyTransferDetails": {
                "fields": {
                  "moneyTransferServerToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RequestedStatementInfo": {
                "fields": {
                  "identifier": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "statementDescription": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "AddressSource": {
                "values": {
                  "UNKNOWN": 0,
                  "GEOCODING_SERVICE": 1,
                  "REDIS": 2,
                  "ROSTER": 3
                }
              },
              "PaymentRoute": {
                "values": {
                  "DEFAULT_PAYMENT_ROUTE_DO_NOT_USE": 0,
                  "GIFTCARD": 1,
                  "AMEX": 2,
                  "CHASE": 3,
                  "VISA": 5,
                  "OMNIPAY": 6,
                  "CUSCAL": 7,
                  "EVERLINK": 8,
                  "SHAZAM_VIA_SHAZAM": 9,
                  "MAESTRO_VIA_SHAZAM": 10,
                  "PULSE_VIA_SHAZAM": 11,
                  "STAR_VIA_STAR_DEBIT": 12,
                  "NYCE_VIA_STAR_DEBIT": 13,
                  "MAESTRO_VIA_STAR_DEBIT": 14,
                  "CAFIS": 15,
                  "FELICA": 16,
                  "SANDBOX": 17,
                  "ALIPAY": 18,
                  "SIMULATOR": 19,
                  "NYCE": 20,
                  "VISA_DEX": 22,
                  "PAY_WITH_CASH": 23,
                  "PAYPAY": 24,
                  "MASTERCARD_MIP": 25,
                  "ACCEL_VIA_NYCE": 26,
                  "PULSE_VIA_NYCE": 27,
                  "EVERLINK_IN_APP": 28,
                  "NYCE_EBT": 29,
                  "AFTERPAY": 30,
                  "STAR_VIA_NYCE": 31,
                  "STAR_VIA_STAR_DEBIT_NORTHEAST": 32,
                  "NYCE_VIA_STAR_DEBIT_NORTHEAST": 33,
                  "MAESTRO_VIA_STAR_DEBIT_NORTHEAST": 34,
                  "SQUARE_ACCOUNT": 35,
                  "JCN": 36,
                  "SIMULATOR_ONLINE": 37,
                  "CERTIFICATION": 38,
                  "FAKE": 39,
                  "MASTERCARD_MIP_AU": 40,
                  "MASTERCARD_MIP_CA": 41,
                  "MASTERCARD_MIP_EU": 42,
                  "MASTERCARD_MIP_UK": 43,
                  "VISA_DEX_AU": 44,
                  "VISA_DEX_CA": 45,
                  "VISA_DEX_EU": 46,
                  "VISA_DEX_UK": 47,
                  "VISA_MDEX_OCT": 48,
                  "VISA_MDEX_AUTH_AFT": 49,
                  "VISA_DEX_US": 50,
                  "DGFT": 51,
                  "MASTERCARD_MIP_US": 52,
                  "DISCOVER_EU": 53,
                  "STARTERGATEWAY": 54,
                  "MASTERCARD_MIP_MAS": 55,
                  "MASTERCARD_MIP_MDFS": 56,
                  "MASTERCARD_MIP_ILIAD": 57,
                  "ADYEN": 58,
                  "MASTERCARD_MIP_US_SMS": 59,
                  "DISCOVER_RCT": 60,
                  "DISCOVER_CCT": 61,
                  "DISCOVER_US": 62,
                  "MASTERCARD_MIP_CA_SMS": 63
                }
              },
              "AccountUpdaterResult": {
                "fields": {
                  "status": {
                    "type": ".squareup.esperanto.common.AccountUpdaterResult.AccountUpdaterStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "panFideliusToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "expirationYymm": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "originalPanFideliusToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "panMasked": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "AccountUpdaterStatus": {
                    "values": {
                      "DEFAULT_ACCOUNT_UPDATER_STATUS_DO_NOT_USE": 1,
                      "NOT_REQUESTED": 2,
                      "NOT_ELIGIBLE": 3,
                      "ACCOUNT_UPDATED": 4,
                      "ACCOUNT_UPDATED_EXPIRATION_ONLY": 5,
                      "ACCOUNT_NOT_UPDATED": 6,
                      "ACCOUNT_CLOSED": 7,
                      "CONTACT_CARDHOLDER": 8,
                      "INTERNAL_ERROR": 9
                    }
                  }
                }
              },
              "GatewayCategorization": {
                "fields": {
                  "authentication3dsDataPopulated": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "customerInitiated": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "posEnvironment": {
                    "type": ".squareup.esperanto.common.GatewayCategorization.PosEnvironment",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "cardReadingMethodUsedAtPos": {
                    "type": ".squareup.esperanto.common.GatewayCategorization.CardReading",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "posCardReadingCapability": {
                    "type": ".squareup.esperanto.common.GatewayCategorization.CardReading",
                    "id": 5,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "PosEnvironment": {
                    "values": {
                      "UNKNOWN_POS_ENVIRONMENT": 0,
                      "ATTENDED_POS": 1,
                      "UNATTENDED_DETAILS_UNKNOWN": 2,
                      "MAIL_ORDER_TELEPHONE_ORDER": 3,
                      "ELECTRONIC_COMMERCE": 4,
                      "MOBILE_COMMERCE": 5,
                      "RECURRING_TRANSACTION": 6,
                      "STORED_DETAILS": 7,
                      "DEFERRED_TRANSACTION": 8,
                      "INSTALLMENT_TRANSACTION": 9
                    }
                  },
                  "CardReading": {
                    "values": {
                      "UNKNOWN_CARD_READING": 0,
                      "INFORMATION_NOT_TAKEN_FROM_CARD": 1,
                      "PHYSICAL": 2,
                      "BAR_CODE": 3,
                      "MAGNETIC_STRIPE": 4,
                      "ICC": 5,
                      "ACCOUNT_DATA_ON_FILE": 6,
                      "ICC_READ_ATTEMPTED_BUT_FAILED": 7,
                      "MAGNETIC_STRIPE_READ_ATTEMPTED_BUT_FAILED": 8,
                      "FALLBACK": 9
                    }
                  }
                }
              },
              "DeclineRetryCategory": {
                "values": {
                  "DEFAULT_DO_NOT_USE": 0,
                  "GENERIC": 1,
                  "TEMPORARY": 2,
                  "DATA_QUALITY": 3,
                  "HARD_DECLINE": 4
                }
              },
              "HealthcareDetails": {
                "fields": {
                  "prescriptionAmountMoney": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "visionAmountMoney": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "dentalAmountMoney": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "otherHealthcareAmountMoney": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "AdviceCode": {
                "values": {
                  "DEFAULT_NO_USE": 0,
                  "NEW_INFO_AVAILABLE": 1,
                  "TRY_AGAIN_LATER": 2,
                  "DO_NOT_REATTEMPT": 3,
                  "PAYMENT_CANCELLATION": 4,
                  "GLOBAL_PAYMENT_CANCELLATION": 5,
                  "NON_RELOADABLE_PREPAID_CARD": 6,
                  "SINGLE_USE_VIRTUAL_CARD": 7,
                  "MULTI_USE_VIRTUAL_CARD": 8,
                  "TOKEN_REQUIREMENTS_UNMET": 9,
                  "NEGOTIATED_VALUE_NOT_APPROVED": 10,
                  "MERCHANT_NOT_QUALIFIED_FOR_PRODUCT": 11
                }
              },
              "AuthenticationResponseData": {
                "fields": {
                  "aavQualityIndicator": {
                    "type": ".squareup.esperanto.common.AuthenticationResponseData.AavQualityIndicator",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "AavQualityIndicator": {
                    "values": {
                      "DEFAULT_DO_NOT_USE": 0,
                      "DOES_NOT_MEET_REQUIREMENTS": 1,
                      "MEETS_REQUIREMENTS": 2
                    }
                  }
                }
              },
              "AppFeeAllocation": {
                "fields": {
                  "amountMoney": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "RefundedAppFeeAllocation": {
                "fields": {
                  "appFeeAllocations": {
                    "type": ".squareup.esperanto.common.AppFeeAllocation",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "refundUuid": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "AsyncMultiBrandTransactionDetails": {
                "fields": {
                  "multiBrandPaymentMethod": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.CustomerPresence && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.OperationStatus && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.ClientPaymentKey && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.ReverseOptions && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.TivoRecord && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.TivoRecord?.nested?.Reason && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.BillInfo && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.MoneyTransferDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.RequestedStatementInfo && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.AddressSource && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.PaymentRoute && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.AccountUpdaterResult && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.AccountUpdaterResult?.nested?.AccountUpdaterStatus && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.GatewayCategorization && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.GatewayCategorization?.nested?.PosEnvironment && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.GatewayCategorization?.nested?.CardReading && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.DeclineRetryCategory && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.HealthcareDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.AdviceCode && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.AuthenticationResponseData && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.AuthenticationResponseData?.nested?.AavQualityIndicator && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.AppFeeAllocation && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.RefundedAppFeeAllocation && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.AsyncMultiBrandTransactionDetails) {
  $root.addJSON(jsonData);
}

/**
 * Customer presence.
 * This class has lowercase names for historical reasons.
 *
 * SOURCE CustomerPresence @ squareup/esperanto/common/common.proto at 16:1
 */
export const CustomerPresence = $root.lookupEnum('squareup.esperanto.common.CustomerPresence').values;
/**
 * A generic result of an operation that can succeed or fail.
 *
 * SOURCE OperationStatus @ squareup/esperanto/common/common.proto at 41:1
 */
export const OperationStatus = $root.lookupType('squareup.esperanto.common.OperationStatus');
fixType(OperationStatus);
Builder.createAndAttachToType(OperationStatus);
/**
 * Client-side identifier for a given payment. This is used for idempotence. The 2-tuple
 * (creator_token, client_uuid) forms cross-datacenter unique identifier.
 *
 * SOURCE ClientPaymentKey @ squareup/esperanto/common/common.proto at 61:1
 */
export const ClientPaymentKey = $root.lookupType('squareup.esperanto.common.ClientPaymentKey');
fixType(ClientPaymentKey, {
  merchantToken: {
    notEmpty: true
  },
  requestId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ClientPaymentKey);
/**
 * SOURCE ReverseOptions @ squareup/esperanto/common/common.proto at 80:1
 */
export const ReverseOptions = $root.lookupType('squareup.esperanto.common.ReverseOptions');
fixType(ReverseOptions);
Builder.createAndAttachToType(ReverseOptions);
/**
 * TiVo related data. Used for "on-us" trasactions.  (Historical, should be no new TiVo payments after 2016-11-01.)
 *
 * SOURCE TivoRecord @ squareup/esperanto/common/common.proto at 122:1
 */
export const TivoRecord = $root.lookupType('squareup.esperanto.common.TivoRecord');
fixType(TivoRecord);
Builder.createAndAttachToType(TivoRecord);
/**
 * Reason the TiVo has been used for this transaction.
 *
 * SOURCE Reason @ squareup/esperanto/common/common.proto at 124:3
 */
TivoRecord.Reason = $root.lookupEnum('squareup.esperanto.common.TivoRecord.Reason').values;
/**
 * Bill level information for split tender.
 *
 * SOURCE BillInfo @ squareup/esperanto/common/common.proto at 144:1
 */
export const BillInfo = $root.lookupType('squareup.esperanto.common.BillInfo');
fixType(BillInfo);
Builder.createAndAttachToType(BillInfo);
/**
 * SOURCE MoneyTransferDetails @ squareup/esperanto/common/common.proto at 156:1
 */
export const MoneyTransferDetails = $root.lookupType('squareup.esperanto.common.MoneyTransferDetails');
fixType(MoneyTransferDetails);
Builder.createAndAttachToType(MoneyTransferDetails);
/**
 * Additional information about the payment to be included on the statement description.
 *
 * SOURCE RequestedStatementInfo @ squareup/esperanto/common/common.proto at 166:1
 */
export const RequestedStatementInfo = $root.lookupType('squareup.esperanto.common.RequestedStatementInfo');
fixType(RequestedStatementInfo);
Builder.createAndAttachToType(RequestedStatementInfo);
/**
 * Address source for the merchant's address
 *
 * SOURCE AddressSource @ squareup/esperanto/common/common.proto at 191:1
 */
export const AddressSource = $root.lookupEnum('squareup.esperanto.common.AddressSource').values;
/**
 * A Route represents a specific way to process a payment.
 *
 * Routes listed here should be granular enough to represent all the different possible ways of
 * processing a given payment without being redundant. E.g. listing AMEX_CA and AMEX_AU would be
 * redundant because these is no single payment that both of those routes could legitimately
 * process. In other words, we SHOULD NOT include subdivisions of routes where eligibility of a
 * payment between the subdivisions is mutually exclusive.
 *
 * SOURCE PaymentRoute @ squareup/esperanto/common/common.proto at 207:1
 */
export const PaymentRoute = $root.lookupEnum('squareup.esperanto.common.PaymentRoute').values;
/**
 * SOURCE AccountUpdaterResult @ squareup/esperanto/common/common.proto at 275:1
 */
export const AccountUpdaterResult = $root.lookupType('squareup.esperanto.common.AccountUpdaterResult');
fixType(AccountUpdaterResult);
Builder.createAndAttachToType(AccountUpdaterResult);
/**
 * SOURCE AccountUpdaterStatus @ squareup/esperanto/common/common.proto at 276:3
 */
AccountUpdaterResult.AccountUpdaterStatus = $root.lookupEnum('squareup.esperanto.common.AccountUpdaterResult.AccountUpdaterStatus').values;
/**
 * Decisioning and categorization that the gateway made before executing the transaction.
 *
 * SOURCE GatewayCategorization @ squareup/esperanto/common/common.proto at 353:1
 */
export const GatewayCategorization = $root.lookupType('squareup.esperanto.common.GatewayCategorization');
fixType(GatewayCategorization);
Builder.createAndAttachToType(GatewayCategorization);
/**
 * Defines a type of environment in which transaction took place.
 * See ISO 8583: "Point of service data code" (bit 22) and item c) "POS environment"
 *               for more information and full list of values.
 *
 * SOURCE PosEnvironment @ squareup/esperanto/common/common.proto at 370:3
 */
GatewayCategorization.PosEnvironment = $root.lookupEnum('squareup.esperanto.common.GatewayCategorization.PosEnvironment').values;
/**
 * Defines card reading method used and card reading capability available during transaction.
 * See ISO 8583: "Point of service data code" (bit 22) and item a) "Card reading method used at POS"
 *               and "Point of service capability" (bit 27) and item a) "POS card reading capability"
 *               for more information and full list of values.
 *
 * SOURCE CardReading @ squareup/esperanto/common/common.proto at 415:3
 */
GatewayCategorization.CardReading = $root.lookupEnum('squareup.esperanto.common.GatewayCategorization.CardReading').values;
/**
 * Set of values that indicates the nature of the decline in regards to reattempt outcome provided
 * by the issuer for an auth, pull, or verification. Visa and Mastercard introduced fee programs
 * that define these categories and impose varying fines. This field is only populated when relevant
 * issuer advice is provided by the processor.
 *
 * Block-internal systems must aim to reduce the volume of retries accordingly. Most importantly,
 * do not retry after receiving "HARD_DECLINE". The other categories have allowances with complex
 * parameters; however, generally retrying ~3 times within a Block server application is reasonable.
 *
 * More details can be found here:
 * https://docs.google.com/document/d/1HZMmPKF7NwoveDIFHlKuSQxJ3LlOmns4qONDyuMTGZo/edit#heading=h.qs59tkdp3cdn
 *
 * SOURCE DeclineRetryCategory @ squareup/esperanto/common/common.proto at 466:1
 */
export const DeclineRetryCategory = $root.lookupEnum('squareup.esperanto.common.DeclineRetryCategory').values;
/**
 * Healthcare-related payment details.
 *
 * SOURCE HealthcareDetails @ squareup/esperanto/common/common.proto at 501:1
 */
export const HealthcareDetails = $root.lookupType('squareup.esperanto.common.HealthcareDetails');
fixType(HealthcareDetails);
Builder.createAndAttachToType(HealthcareDetails);
/**
 * This field is a recommendation on whether the card should be unlinked, tried again later, or
 * not attempted again.
 *
 * SOURCE AdviceCode @ squareup/esperanto/common/common.proto at 528:1
 */
export const AdviceCode = $root.lookupEnum('squareup.esperanto.common.AdviceCode').values;
/**
 * Contains network or issuer-supplied data related to the Authentication
 *
 * SOURCE AuthenticationResponseData @ squareup/esperanto/common/common.proto at 590:1
 */
export const AuthenticationResponseData = $root.lookupType('squareup.esperanto.common.AuthenticationResponseData');
fixType(AuthenticationResponseData);
Builder.createAndAttachToType(AuthenticationResponseData);
/**
 * Represents if the provided authentication cryptogram does or does not meet the issuer's
 * authentication data quality requirements.
 *
 * SOURCE AavQualityIndicator @ squareup/esperanto/common/common.proto at 595:3
 */
AuthenticationResponseData.AavQualityIndicator = $root.lookupEnum('squareup.esperanto.common.AuthenticationResponseData.AavQualityIndicator').values;
/**
 * SOURCE AppFeeAllocation @ squareup/esperanto/common/common.proto at 603:1
 */
export const AppFeeAllocation = $root.lookupType('squareup.esperanto.common.AppFeeAllocation');
fixType(AppFeeAllocation);
Builder.createAndAttachToType(AppFeeAllocation);
/**
 * SOURCE RefundedAppFeeAllocation @ squareup/esperanto/common/common.proto at 612:1
 */
export const RefundedAppFeeAllocation = $root.lookupType('squareup.esperanto.common.RefundedAppFeeAllocation');
fixType(RefundedAppFeeAllocation);
Builder.createAndAttachToType(RefundedAppFeeAllocation);
/**
 * SOURCE AsyncMultiBrandTransactionDetails @ squareup/esperanto/common/common.proto at 621:1
 */
export const AsyncMultiBrandTransactionDetails = $root.lookupType('squareup.esperanto.common.AsyncMultiBrandTransactionDetails');
fixType(AsyncMultiBrandTransactionDetails);
Builder.createAndAttachToType(AsyncMultiBrandTransactionDetails);